import { nextApiEndpoint } from '@/constant/env';

import { Logger } from '../Logging';
import {
  ControlledTextModalsResponse,
  NormalizedGlobalTextModalProps,
} from './types';

const logger = new Logger('GlobalModalProvider/utils.ts');

export function normalizeHash(hash: string) {
  return hash.replace('#', '');
}

export function normalizeControlledTextModalsResponseData(
  data: ControlledTextModalsResponse
): NormalizedGlobalTextModalProps[] {
  if (!data?.data) {
    logger.error({
      message: 'Invalid controlled text modals response data',
      context: data,
    });
    return [];
  }

  return data.data.map((modal) => ({
    title: modal.title,
    content: modal.content,
    triggerHash: normalizeHash(modal.triggerHash),
    enabled: modal.enabled,
  }));
}

export function fetchControlledTextModals(): Promise<
  NormalizedGlobalTextModalProps[]
> {
  return fetch(`${nextApiEndpoint}/modals`)
    .then((r) => r.json() as Promise<ControlledTextModalsResponse>)
    .then(normalizeControlledTextModalsResponseData)
    .catch((error) => {
      logger.error({
        message: 'Error initializing global modals',
        context: error,
      });

      return [];
    });
}
